// List of available locales based on the JSON files in public/locales
const VALID_LOCALES = [
	"ar-AE",
	"en-AE",
	"en-AU",
	"en-CA",
	"en-GB",
	"en-NZ",
	"en-US",
	"es-MX",
	"es-US",
	"fr-CA",
	"pt-BR",
] as const

// Type for valid locales
export type ValidLocale = (typeof VALID_LOCALES)[number]

/**
 * Validates if a string is a valid locale
 * @param locale - The locale string to validate
 * @returns true if the locale is valid, false otherwise
 */
function isValidLocale(locale: string): locale is ValidLocale {
	return VALID_LOCALES.includes(locale as ValidLocale)
}

interface LocaleContextType {
	locale: ValidLocale
	layoutDir: "rtl" | "ltr"
	isRTL: boolean
}

export {isValidLocale, VALID_LOCALES, type LocaleContextType}
